import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import SectionHeading from "@/components/base/SectionHeading";
import { galleryItems } from "@/data/gallery";

/**
 * "Inside our clinic" strip — real photographs from the practice with a
 * link through to the full gallery.
 */
export default function InsideClinic() {
  const tiles = galleryItems.slice(3, 7);

  return (
    <section className="bg-gradient-to-b from-background-50 to-accent-50/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <SectionHeading
            eyebrow="Inside Our Clinic"
            title="A closer look at where we care for you"
            align="left"
            description="Real moments from consultations and examinations at Ortho Spine Care — because good care begins with listening."
          />
          <Button to="/gallery" variant="outline" size="md" icon="ri-image-2-line">
            View Gallery
          </Button>
        </div>

        <div className="reveal mt-10 grid grid-cols-2 gap-3 lg:grid-cols-4">
          {tiles.map((item) => (
            <Link
              key={item.title}
              to="/gallery"
              className="group relative h-[190px] cursor-pointer overflow-hidden rounded-2xl border border-background-200 sm:h-[240px]"
            >
              <img
                src={item.image}
                alt={item.alt}
                title={`${item.title} — Ortho Spine Care gallery`}
                className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-primary-950/0 transition-all duration-300 group-hover:bg-gradient-to-t group-hover:from-primary-950/80 group-hover:via-accent-950/30 group-hover:to-transparent"
                aria-hidden="true"
              ></div>
              <span className="absolute bottom-3 left-3 right-3 translate-y-2 font-label text-xs font-semibold text-background-50 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                {item.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}